<template>
  <div>
    <div class="text-center" v-if="!examStudent">
        <b-spinner style="margin-top: 100px; width: 3rem; height: 3rem;" variant="primary" label="Spinning"></b-spinner>
    </div>    
    <div class="home" v-if="examStudent">
        <b-navbar toggleable="lg" type="dark" variant="dark">
          <b-navbar-brand href="#">qAssess Student</b-navbar-brand>
          <b-navbar-nav class="ml-auto">    
              <b-button variant="primary" @click="$router.push({ name: 'Help'})" class="mr-sm-4"><b-icon-question-circle></b-icon-question-circle> &nbsp; Help</b-button>                   
              <b-button variant="info" @click="$router.push({ name: 'Logout'})"><b-icon-box-arrow-right></b-icon-box-arrow-right> &nbsp; Logout</b-button>
          </b-navbar-nav>
        </b-navbar>

        <div class="container mt-3">
          <div class="row justify-content-center">
            <div class="col-xs-12 col-lg-8">
              <b-alert variant="danger" class="d-block d-sm-none" show><strong>Warning:</strong> Screen/browser window is too narrow to properly use qAssess.  Widen the window or use a larger device.</b-alert>

              <StudentInfo v-if="examStudent" :examStudent="examStudent" />
              <br>
              <TaskList v-if="examStudent" :examName="examStudent.examName" :examStudentId="examStudent.examStudentId" />

              <div class="alert alert-danger mt-4"  v-if="hasError"><strong>Error:</strong> Could not load data.</div>
            </div>
          </div>
        </div>   
    </div>
  </div>
</template>

<script>
import TaskList from '@/components/TaskList.vue'
import StudentInfo from '@/components/StudentInfo.vue'

export default {
  name: 'Home',
  components: {
    TaskList,
    StudentInfo
  },
  data() {
      return {
          examStudent: null,
          hasError: false
      }
  },
  mounted() {
      this.getStudent();
  },
  methods: {
      getStudent() {
          this.$http
              .get('/examstudent')
                .then(response => {
                    this.examStudent = response.data; 
                })
                .catch(error => {
                    console.log(error);
                    this.hasError = true;
                });
      }
  }  
}
</script>

<style scoped>
@media (min-width: 576px) {
    .navbar-expand-lg .navbar-nav {
        flex-direction: row;
    }
}
</style>